'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _NicklistUser = require('./NicklistUser');

var _NicklistUser2 = _interopRequireDefault(_NicklistUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Nicklist');

var intlCollator = null;
if (global.Intl) {
    intlCollator = new Intl.Collator({}, { numeric: true });
}

function strCompare(a, b) {
    if (intlCollator) {
        return intlCollator.compare(a, b);
    }

    if (a === b) {
        return 0;
    }

    return a > b ? 1 : -1;
}

exports.default = {
    components: {
        NicklistUser: _NicklistUser2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            userbox_user: null,
            user_filter: '',
            filter_visible: false,
            self: this
        };
    },
    computed: {
        sortedUsers: function sortedUsers() {
            var _this = this;

            var netPrefixes = this.network.ircClient.network.options.PREFIX;
            var prefixOrders = (0, _create2.default)(null);
            netPrefixes.forEach(function (prefix, idx) {
                prefixOrders[prefix.mode] = idx;
            });

            var nickMap = (0, _create2.default)(null);
            var users = [];
            var bufferUsers = this.buffer.users;
            var nickFilter = this.user_filter.toLowerCase();

            for (var lowercaseNick in bufferUsers) {
                var user = bufferUsers[lowercaseNick];
                nickMap[user.nick] = lowercaseNick;
                if (!nickFilter || lowercaseNick.indexOf(nickFilter) !== -1) {
                    users.push(user);
                }
            }

            var bufferId = this.buffer.id;
            return users.sort(function (a, b) {
                var bufferA = a.buffers[bufferId];
                var bufferB = b.buffers[bufferId];

                if (!bufferA) {
                    var msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
                    log.error(msg, a.nick, a.buffers);
                    return -1;
                }
                if (!bufferB) {
                    var _msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
                    log.error(_msg, b.nick, b.buffers);
                    return 1;
                }

                var modesA = bufferA.modes;
                var modesB = bufferB.modes;

                if (modesA.length === 0 && modesB.length === 0) {
                    return strCompare(nickMap[a.nick], nickMap[b.nick]);
                }

                if (modesA.length > 0 && modesB.length === 0) {
                    return -1;
                }

                if (modesA.length === 0 && modesB.length > 0) {
                    return 1;
                }

                var aP = prefixOrders[_this.buffer.userMode(a)];
                var bP = prefixOrders[_this.buffer.userMode(b)];
                if (aP > bP) {
                    return 1;
                } else if (aP < bP) {
                    return -1;
                }

                return strCompare(nickMap[a.nick], nickMap[b.nick]);
            });
        },
        useColouredNicks: function useColouredNicks() {
            return this.buffer.setting('coloured_nicklist');
        }
    },
    methods: {
        userModePrefix: function userModePrefix(user) {
            return this.buffer.userModePrefix(user);
        },
        userMode: function userMode(user) {
            return this.buffer.userMode(user);
        },
        openQuery: function openQuery(user) {
            var buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
            this.$state.setActiveBuffer(buffer.networkid, buffer.name);
            if (this.$state.ui.is_narrow) {
                this.sidebarState.close();
            }
        },
        openUserbox: function openUserbox(user) {
            this.$state.$emit('userbox.show', user, {
                buffer: this.buffer
            });
        },
        toggleUserFilter: function toggleUserFilter() {
            var _this2 = this;

            this.filter_visible = !this.filter_visible;
            if (this.filter_visible) {
                this.$nextTick(function () {
                    return _this2.$refs.user_filter.focus();
                });
            } else {
                this.user_filter = '';
            }
        },
        onFilterBlur: function onFilterBlur() {
            if (!this.user_filter) {
                this.filter_visible = false;
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Nicklist"]
window._kiwi_exports.components.Nicklist = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Nicklist.vue
// module id = MMNQ
// module chunks = 1